/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_In_Frost_FreeInputs */



/**
* | output |
* | --- |
* | "The network is in frost-free mode" |
*
* @param {Network_In_Frost_FreeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_in_frost_free = /** @type {((inputs?: Network_In_Frost_FreeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_In_Frost_FreeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The network is in frost-free mode")
	return /** @type {LocalizedString} */ ("Le réseau est en mode hors-gel")
});